import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import { getARVFacilityList } from "../../../services/Common";
import DispenserFormData from "./DispenserFormData.js";
import encryptionService from "../../../services/encryptionService";


const EditDispenser = (props) => {
  
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "dispenser";
  const FacilityId = localStorage.getItem("FacilityId");

  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  //const FacilityList = JSON.parse(localStorage.getItem("FacilityList"));
  const FacilityList = getARVFacilityList(); 
  const [generatedNumber, setgeneratedNumber] = useState("");

  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    initial: "",
    title: "",
    rxLevel: "",
    number: "",
    professional: "",
    staff: "",
    post: "",
    demander: "",
    active: false,
    address1: "",
    contactNumber: "",
    contactNumberEmergency: "",
    city: "",
    emailWork: "",
    country: "",
    emailPersonal: "",
    UserId: "",
  });
  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { data } = useQuery(
    ["dispenser", id],
    () =>
      api.getDispenser(id).then((res) => {
        let TemNumber = res.data.number.split("-");
        setgeneratedNumber(TemNumber[2]);
        setFormData(res.data);
        return res.data;
      }),
    {
      enabled: Boolean(id),
    }
  );

  const { isLoading, mutate } = useMutation(api.updateDispenser, {
    onSuccess: (data) => {
      if (data.status == 200) {

        if(FacilityId == data.FacilityId){
          api.getFacilityListNotEqual99ANDSuppliers('DispenserList', data.FacilityId).then((response) => {
            localStorage.setItem(
              "DispenserList",
              JSON.stringify(response.datalist.DispenserList)
            );
          })
       }

        queryClient.getQueriesData("dispenser");
        props.history.push("/dispenser");

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;
    if (name == "demander") {
      for (let i = 0; i < FacilityList.length; i++) {
        if (value == FacilityList[i].id) {
          data["number"] =
            "D-" + FacilityList[i].FacilityCode + "-" + generatedNumber;
          setFormData(data);
        }
      }
    } else setFormData(data);
    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      lastName: "",
      firstName: "",
      initial: "",
      title: "",
      rxLevel: "",
      number: "",
      professional: "",
      staff: "",
      post: "",
      demander: "",
      active: false,
      address1: "",
      contactNumber: "",
      contactNumberEmergency: "",
      city: "",
      emailWork: "",
      country: "",
      emailPersonal: "",
      UserId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = [
      "lastName",
      "firstName",
      "rxLevel",
      "number",
      "demander",
    ];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleUpdate = async (e) => {
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        menukey: menukey,
        lan: lan,
        UserName: UserName,
      };
      mutate(fDtat);
    }
  };

      //====== Start Choosen Dropdown===========
      const handleChangeChoosenProps = (name, value) => {
        let data = { ...formData };
        data[name] = value;   
        setFormData(data); 
        setErrorObject({ ...errorObject, [name]: "" });
          
      }
      //====== End Choosen Dropdown===========

  return (
    <>
      <DispenserFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        handleChangeChoosenProps={handleChangeChoosenProps}
        {...props}
      />
    </>
  );
};

export default EditDispenser;
